
import { supabase } from '@/integrations/supabase/client';

// Helper function to check if staff can manage a user
export const canStaffManageUser = async (targetUserId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase.rpc('can_staff_manage_user', {
      target_user_id: targetUserId
    });

    if (error) {
      console.error('Error checking staff permissions:', error);
      return false;
    }

    return data || false;
  } catch (error) {
    console.error('Error in canStaffManageUser:', error);
    return false;
  }
};

// Helper function to log staff actions
export const logStaffUserAction = async (
  targetUserId: string,
  actionType: string,
  actionDetails: any = {},
  ipAddress?: string,
  userAgent?: string
): Promise<void> => {
  try {
    const { error } = await supabase.rpc('log_staff_user_action', {
      target_user_id: targetUserId,
      action_type: actionType,
      action_details: actionDetails,
      ip_address: ipAddress,
      user_agent: userAgent
    });

    if (error) {
      console.error('Error logging staff action:', error);
    }
  } catch (error) {
    console.error('Error in logStaffUserAction:', error);
  }
};
